module.exports = __webpack_public_path__ + "img/Qi_Tian@2x.bc52f9a4.png";